"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFakeUploadImpression = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var data = {
    audio: [{
            fileData: {
                "kind": "storage#object",
                "id": "cata_dev__media/audios/sampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav/1694442705602562",
                "selfLink": "https://www.googleapis.com/storage/v1/b/cata_dev__media/o/audios%2Fsampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav",
                "mediaLink": "https://storage.googleapis.com/download/storage/v1/b/cata_dev__media/o/audios%2Fsampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav?generation=1694442705602562&alt=media",
                "name": "audios/sampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav",
                "bucket": "cata_dev__media",
                "generation": "1694442705602562",
                "metageneration": "1",
                "contentType": "audio/wav",
                "storageClass": "STANDARD",
                "size": 10544134,
                "md5Hash": "G4cmpod1v6ysmkrndou8kQ==",
                "crc32c": "SAkgWg==",
                "etag": "CIKQvfziooEDEAE=",
                "timeCreated": "2023-09-11T14:31:45.605Z",
                "updated": "2023-09-11T14:31:45.605Z",
                "timeStorageClassUpdated": "2023-09-11T14:31:45.605Z",
                "originalFilename": "sampleaudio3.wav",
                "mediaHost": "gcs",
                "publicUrl": "https://storage.googleapis.com/cata_dev__media/audios/sampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav"
            },
        }],
    video: [{
            fileData: {
                "kind": "storage#object",
                "id": "cata_dev__media/videos/file_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4/1694442756300353",
                "selfLink": "https://www.googleapis.com/storage/v1/b/cata_dev__media/o/videos%2Ffile_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4",
                "mediaLink": "https://storage.googleapis.com/download/storage/v1/b/cata_dev__media/o/videos%2Ffile_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4?generation=1694442756300353&alt=media",
                "name": "videos/file_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4",
                "bucket": "cata_dev__media",
                "generation": "1694442756300353",
                "metageneration": "1",
                "contentType": "video/mp4",
                "storageClass": "STANDARD",
                "size": 17839845,
                "md5Hash": "16PezbYoDrDvOgWaw16g7g==",
                "crc32c": "xo062A==",
                "etag": "CMG805TjooEDEAE=",
                "timeCreated": "2023-09-11T14:32:36.302Z",
                "updated": "2023-09-11T14:32:36.302Z",
                "timeStorageClassUpdated": "2023-09-11T14:32:36.302Z",
                "originalFilename": "file_example_MP4_1920_18MG.mp4",
                "mediaHost": "gcs",
                "publicUrl": "https://storage.googleapis.com/cata_dev__media/videos/file_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4"
            }
        }],
    pdf: [{
            fileData: {
                "kind": "storage#object",
                "id": "dev-okf-assets-01/demo/pdfs/70afac90-134a-42b7-863f-3d76739636e9.pdf/1695017447246490",
                "selfLink": "https://www.googleapis.com/storage/v1/b/dev-okf-assets-01/o/demo%2Fpdfs%2F70afac90-134a-42b7-863f-3d76739636e9.pdf",
                "mediaLink": "https://storage.googleapis.com/download/storage/v1/b/dev-okf-assets-01/o/demo%2Fpdfs%2F70afac90-134a-42b7-863f-3d76739636e9.pdf?generation=1695017447246490&alt=media",
                "name": "demo/pdfs/70afac90-134a-42b7-863f-3d76739636e9.pdf",
                "bucket": "dev-okf-assets-01",
                "generation": "1695017447246490",
                "metageneration": "1",
                "contentType": "application/pdf",
                "storageClass": "STANDARD",
                "size": "54836",
                "md5Hash": "a7SSw4MkD82HtcQpWMLkgg==",
                "crc32c": "aDpX1g==",
                "etag": "CJqV04bAs4EDEAE=",
                "timeCreated": "2023-09-18T06:10:47.301Z",
                "updated": "2023-09-18T06:10:47.301Z",
                "timeStorageClassUpdated": "2023-09-18T06:10:47.301Z",
                "mediaHost": "gcs",
                "originalFilename": "sample.pdf",
                "format": "pdf",
                "publicUrl": "https://storage.googleapis.com/dev-okf-assets-01/demo/pdfs/70afac90-134a-42b7-863f-3d76739636e9.pdf"
            }
        }],
    resource: [
        {
            fileData: {
                "kind": "storage#object",
                "id": "dev-okf-assets-01/demo/pdfs/70afac90-134a-42b7-863f-3d76739636e9.pdf/1695017447246490",
                "selfLink": "https://www.googleapis.com/storage/v1/b/dev-okf-assets-01/o/demo%2Fpdfs%2F70afac90-134a-42b7-863f-3d76739636e9.pdf",
                "mediaLink": "https://storage.googleapis.com/download/storage/v1/b/dev-okf-assets-01/o/demo%2Fpdfs%2F70afac90-134a-42b7-863f-3d76739636e9.pdf?generation=1695017447246490&alt=media",
                "name": "demo/pdfs/70afac90-134a-42b7-863f-3d76739636e9.pdf",
                "bucket": "dev-okf-assets-01",
                "generation": "1695017447246490",
                "metageneration": "1",
                "contentType": "application/pdff",
                "storageClass": "STANDARD",
                "size": "54836",
                "md5Hash": "a7SSw4MkD82HtcQpWMLkgg==",
                "crc32c": "aDpX1g==",
                "etag": "CJqV04bAs4EDEAE=",
                "timeCreated": "2023-09-18T06:10:47.301Z",
                "updated": "2023-09-18T06:10:47.301Z",
                "timeStorageClassUpdated": "2023-09-18T06:10:47.301Z",
                "mediaHost": "gcs",
                "originalFilename": "sample.pdf",
                "publicUrl": "https://storage.googleapis.com/dev-okf-assets-01/demo/pdfs/70afac90-134a-42b7-863f-3d76739636e9.pdf"
            }
        },
        {
            fileData: {
                "kind": "storage#object",
                "id": "cata_dev__media/videos/file_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4/1694442756300353",
                "selfLink": "https://www.googleapis.com/storage/v1/b/cata_dev__media/o/videos%2Ffile_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4",
                "mediaLink": "https://storage.googleapis.com/download/storage/v1/b/cata_dev__media/o/videos%2Ffile_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4?generation=1694442756300353&alt=media",
                "name": "videos/file_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4",
                "bucket": "cata_dev__media",
                "generation": "1694442756300353",
                "metageneration": "1",
                "contentType": "video/mp4",
                "storageClass": "STANDARD",
                "size": 17839845,
                "md5Hash": "16PezbYoDrDvOgWaw16g7g==",
                "crc32c": "xo062A==",
                "etag": "CMG805TjooEDEAE=",
                "timeCreated": "2023-09-11T14:32:36.302Z",
                "updated": "2023-09-11T14:32:36.302Z",
                "timeStorageClassUpdated": "2023-09-11T14:32:36.302Z",
                "originalFilename": "file_example_MP4_1920_18MG.mp4",
                "mediaHost": "gcs",
                "publicUrl": "https://storage.googleapis.com/cata_dev__media/videos/file_example_mp4_1920_18mg_1dded13e-9090-4477-b00e-78591823fd41.mp4"
            }
        },
        {
            fileData: {
                "kind": "storage#object",
                "id": "cata_dev__media/audios/sampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav/1694442705602562",
                "selfLink": "https://www.googleapis.com/storage/v1/b/cata_dev__media/o/audios%2Fsampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav",
                "mediaLink": "https://storage.googleapis.com/download/storage/v1/b/cata_dev__media/o/audios%2Fsampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav?generation=1694442705602562&alt=media",
                "name": "audios/sampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav",
                "bucket": "cata_dev__media",
                "generation": "1694442705602562",
                "metageneration": "1",
                "contentType": "audio/wav",
                "storageClass": "STANDARD",
                "size": 10544134,
                "md5Hash": "G4cmpod1v6ysmkrndou8kQ==",
                "crc32c": "SAkgWg==",
                "etag": "CIKQvfziooEDEAE=",
                "timeCreated": "2023-09-11T14:31:45.605Z",
                "updated": "2023-09-11T14:31:45.605Z",
                "timeStorageClassUpdated": "2023-09-11T14:31:45.605Z",
                "originalFilename": "sampleaudio3.wav",
                "mediaHost": "gcs",
                "publicUrl": "https://storage.googleapis.com/cata_dev__media/audios/sampleaudio3_d9022d06-c304-4fbb-ade6-7d0784704768.wav"
            },
        }
    ]
};
var useFakeUploadImpression = function (options) {
    if (options === void 0) { options = {}; }
    var handleUploadProgess = options.handleUploadProgess, fileType = options.fileType;
    var _a = (0, react_1.useState)(false), isLoading = _a[0], setIsLoading = _a[1];
    var simulateUploadProgress = function () {
        var progress = 0;
        var interval = setInterval(function () {
            if (progress < 100) {
                var increment = Math.floor(Math.random() * (101 - progress)); // Randomly increment up to remaining progress
                progress = Math.min(progress + increment, 100);
                handleUploadProgess && handleUploadProgess(progress);
            }
            else {
                clearInterval(interval);
                setIsLoading(false);
            }
        }, 500); //interval duration as needed
        return interval;
    };
    var mutate = function (files, callbacks) {
        if (callbacks === void 0) { callbacks = {}; }
        if (fileType === "resource" && files.length > 0) {
            var fileTypeData = data[fileType];
            // Repeat the data from data[fileType] until it matches the length of received files
            while (fileTypeData.length < files.length) {
                fileTypeData.push.apply(fileTypeData, fileTypeData);
            }
            // Select files from repeated data[fileType] and update the id
            var selectedFiles = fileTypeData.slice(0, files.length);
            files = selectedFiles.map(function (file) { return ({
                fileData: __assign(__assign({}, file.fileData), { id: (0, lodash_1.uniqueId)() }),
                status: "success"
            }); });
        }
        else {
            // Use the hardcoded data for other fileTypes
            var fileTypeData = data[fileType] && data[fileType][0];
            files = fileTypeData ? [{ fileData: fileTypeData.fileData, status: "success" }] : [];
        }
        var onSuccess = callbacks.onSuccess;
        setIsLoading(true);
        // Simulate upload progress with setInterval
        var uploadInterval = simulateUploadProgress();
        // Simulate a successful upload after a delay (you can modify this as needed)
        setTimeout(function () {
            clearInterval(uploadInterval);
            setIsLoading(false);
            onSuccess(files);
        }, 3000); // Adjust the delay duration as needed
    };
    return { mutate: mutate, isLoading: isLoading };
};
exports.useFakeUploadImpression = useFakeUploadImpression;
